import React from 'react';
import PropTypes from 'prop-types';

import Grid from 'material-ui/Grid';
import { withStyles } from 'material-ui/styles';
import MaterialChart from '../../../common/MaterialChart';

const styles = theme => ({
  root: {
    minHeight: 370,
    marginTop: theme.spacing.unit * 3,
    overflowY: 'visible',
  }
})

export const ImpedanceCharts = (props) => {
  const {
    classes,
    characteristicImpedance,
    differentialImpedance,
    propagationalDelay
  } = props;

  return (
    <Grid container className={classes.root}>
      {characteristicImpedance.data && characteristicImpedance.data.length > 0 
        ? (
          <Grid item xs={12} sm={12} md={6}>
            <MaterialChart
              data={characteristicImpedance.data}
              keys={characteristicImpedance.keys}
              mhzs={characteristicImpedance.mhzs}
              label="Characteristic Impedance"
            />
          </Grid>
        ) : null}
      {differentialImpedance.data && differentialImpedance.data.length > 0
        ? (
          <Grid item xs={12} sm={12} md={6}>
            <MaterialChart
              data={differentialImpedance.data}
              keys={differentialImpedance.keys}
              mhzs={differentialImpedance.mhzs}
              label="Differential Impedance"
            />
          </Grid>
        ) : null}
      {propagationalDelay.data && propagationalDelay.data.length > 0
        ? (
          <Grid item xs={12} sm={12} md={6}>
            <MaterialChart
              data={propagationalDelay.data}
              keys={propagationalDelay.keys}
              mhzs={propagationalDelay.mhzs}
              label="Propagational Delay"
            />
          </Grid>
        ) : null}
    </Grid>
  );
}

export const chartDataPropTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  keys: PropTypes.arrayOf(PropTypes.string),
  mhzs: PropTypes.arrayOf(PropTypes.string),
}

ImpedanceCharts.propTypes = {
  classes:                 PropTypes.objectOf(PropTypes.string).isRequired,
  characteristicImpedance: PropTypes.shape(chartDataPropTypes).isRequired,
  differentialImpedance:   PropTypes.shape(chartDataPropTypes).isRequired,
  propagationalDelay:      PropTypes.shape(chartDataPropTypes).isRequired,
}

export default  withStyles(styles)(ImpedanceCharts);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/ImpedanceCharts.js